ObjectUtils.define('UIControlController', UIController, {

  setEnabled: function setEnabled(container, enabled) {
    DOM.addClassIf(container, 'enabled', enabled, 'disabled');
  },

  setSelected: function setSelected(container, selected) {
    DOM.addClassIf(container, 'selected', selected, 'unselected');
  },

  shouldAutoSubmit: function shouldAutoSubmit(container) {
    return DOM.getAttribute(container, 'autosubmit') == 'true';
  }

});
